import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useUserContext } from "./UserContext";

const EmployeeRoute: React.FC = () => {
  const { getUser } = useUserContext();
  const user = getUser();

  if (user?.idCliente) {
    return <Navigate to="/clientes/portal" replace />;
  }

  return <Outlet />;
};

export default EmployeeRoute;
